import { cn } from "@/lib/utils";

export function Tabs({
  tabs, value, onChange,
}: {
  tabs: { value: string; label: string; count?: number }[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div className="inline-flex h-9 items-center gap-1 rounded-lg border bg-muted/40 p-1">
      {tabs.map((t) => (
        <button
          key={t.value}
          onClick={() => onChange(t.value)}
          className={cn(
            "flex h-7 items-center gap-1.5 rounded-md px-3 text-xs font-medium transition-colors",
            value === t.value
              ? "bg-card text-foreground shadow-sm ring-1 ring-border"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {t.label}
          {t.count !== undefined && (
            <span className={cn(
              "rounded-full px-1.5 py-0.5 text-[10px] leading-none num",
              value === t.value ? "bg-primary/15 text-primary" : "bg-muted text-muted-foreground",
            )}>
              {t.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
